import ApiService from '../common/api.service';

import {
  FETCH_IMAGE,
  FETCH_FORMACIONES,
  ADD_FORMACION,
  REMOVE_FORMACION,
} from './actions.type';

import {
  SET_ERROR,
} from './mutations.type';


/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
};

const getters = {
};

const actions = {
  [FETCH_IMAGE](context, image, originalContext) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.queryBlob(`rh/rh_evidence_image/${image}`)
        .then(({ data }) => {
          const buffer = Buffer.from(data, 'base64').toString('base64');
          resolve(buffer);
        })
        .catch(() => {
        });
    });
  },
  [FETCH_FORMACIONES](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('rh/formaciones', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [ADD_FORMACION](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('rh/agregar_formacion', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [REMOVE_FORMACION](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('rh/eliminar_formacion', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
